/*
    [{
        "uuid": "32fdd-d2334f34-c43c34f-f4434f34",
        "name":"Test",
        "options":{
            "desiredLayers":["Water","Sewer","Storm","Contours","Parcels","Aerials","GPS SURVEY","Power"],
            "outputFormats":["DWG","DGN","SHP","KMZ","PDF"]
        },
        "area_wkt":"POLYGON((-111.67438692366767 40.24946308177127,-111.69109641527818 40.243618172624736,-111.6778483144014 40.23609889146823,-111.66613108431983 40.24270914665985,-111.67438692366767 40.24946308177127))",
        "status": "PENDING",
        "createdAt": "2025-03-06 12:24:01.444Z",
        "completedAt": "2025-03-06 12:26:04.254Z",
        "failedReason": ""
    }]
*/



import React, { Component } from "react";
import Header from "../../components/header/Header";
import {
  Table,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Col,
  Input
} from "reactstrap";
import Loading from "../../components/preloader/Loading";
import httpClient from "../../services/HttpClient";

class RequestsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [],
      limit: 10,
      currentPage: 1,
      isLoading: false,
      searchQuery: '',
      searchTimeout: null
    };
  }

  componentDidMount() {
    this.fetchRequests(1);
  }


  createNewRequest = () => {
    if (window.location.hash === "#/main") {
      // Temporarily change the hash to trigger a reload
      window.location.hash = "#/reload";
      setTimeout(() => {
        window.location.hash = "#/main";
      }, 0); // Change back to #/main
    } else {
      // Navigate to #/main
      window.location.href = "#/main";
    }
  }

  handleSearchChange = (e) => {
    const searchQuery = e.target.value;
    this.setState({ searchQuery });

    // Clear any existing timeout
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    // Set a new timeout for debouncing
    const searchTimeout = setTimeout(() => {
      this.fetchRequests(1);
    }, 1000); // 1 second delay

    this.setState({ searchTimeout });
  };

  fetchRequests = (page) => {
    const { limit, searchQuery } = this.state;
    const offset = (page - 1) * limit;

    
    this.setState({ isLoading: true });

    httpClient
      .get(`/request?offset=${offset}&limit=${limit}&search=${searchQuery}`)
      .then((response) => {
        this.setState({
          requests: response.data,
          currentPage: page,
        });
      })
      .catch((error) => {
        console.error("Error fetching requests:", error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
      
     /*
      this.setState({
        requests: [{
            "uuid": "32fdd-d2334f34-c43c34f-f4434f34",
            "name":"Test Project 24534",
            "options":{
                "desiredLayers":["Water","Sewer","Storm","Contours","Parcels","Aerials","GPS SURVEY","Power"],
                "outputFormats":["DWG","DGN","SHP","KMZ","PDF"]
            },
            "area_wkt":"POLYGON((-111.67438692366767 40.24946308177127,-111.69109641527818 40.243618172624736,-111.6778483144014 40.23609889146823,-111.66613108431983 40.24270914665985,-111.67438692366767 40.24946308177127))",
            "status": "COMPLETE",
            "createdAt": "2025-03-06 12:24:01.444Z",
            "completedAt": "2025-03-06 12:26:04.254Z",
            "failedReason": ""
        },
        {
            "uuid": "32fdd-d2334f34-c43c34f-45nj4r3nj",
            "name":"Test Project 24534",
            "options":{
                "desiredLayers":["Water","Sewer","Storm","Contours","Parcels","Aerials","GPS SURVEY","Power"],
                "outputFormats":["DWG","DGN","SHP","KMZ","PDF"]
            },
            "area_wkt":"POLYGON((-111.67438692366767 40.24946308177127,-111.69109641527818 40.243618172624736,-111.6778483144014 40.23609889146823,-111.66613108431983 40.24270914665985,-111.67438692366767 40.24946308177127))",
            "status": "COMPLETE",
            "createdAt": "2025-03-06 12:24:01.444Z",
            "completedAt": "2025-03-06 12:26:04.254Z",
            "failedReason": ""
        }],
        currentPage: page,
      });
      */
  };

  getFormattedDate = (dateString) => {
    if (!dateString) return "";
    const normalized = dateString.endsWith("Z") ? dateString : `${dateString}Z`;
    const date = new Date(normalized);
    return date.toLocaleString();
  };

  render() {
    const { requests, currentPage, limit, isLoading, searchQuery } = this.state;

    return (
      <>
        <Loading isOpen={isLoading} />
        <Header />
        <div className="container mt-5">
          <h1>My Requests</h1>
          <Row>
              <Col md="6">
                  <Input
                      type="text"
                      placeholder="Search on request name..."
                      style={{width: 400}}
                      value={searchQuery}
                      onChange={this.handleSearchChange}
                  />
              </Col>
              <Col md="6">
                  <Button className="btn btn-success rounded-pill" style={{float: 'right'}} onClick={() => this.createNewRequest()}>Create New Request</Button>
              </Col>
          </Row>
          <Table className="mt-3" bordered>
            <thead>
              <tr>
                <th style={{ width: "250px" }}>Name</th>
                <th>Desired Layers</th>
                <th>Output Formats</th>
                <th>Status</th>
                <th>Requested At</th>
                <th>Completed At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {requests.length > 0 ? (
                requests.map((request) => (
                  <tr key={request.uuid}>
                    <td style={{ width: "250px" }}>{request.name}</td>
                    <td>{request.options.desiredLayers.join(", ")}</td>
                    <td>{request.options.outputFormats.join(", ")}</td>
                    <td>{request.status}</td>
                    <td>{this.getFormattedDate(request.createdAt)}</td>
                    <td>
                      {request.completedAt
                        ? this.getFormattedDate(request.completedAt)
                        : "Not Completed"}
                    </td>
                    <td>
                    {request.completedAt &&
                      <Button
                        className="rounded-pill"
                        color="primary"
                        size="sm"
                        disabled={request.status !== "COMPLETE"}
                        onClick={() =>
                          window.open(`${window.clipship_config.UiBaseUrl}/download?uuid=${request.uuid}`, "_blank")
                        }
                      >
                        Download
                      </Button>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No requests found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <Pagination>
            {/* Previous Button */}
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                previous
                onClick={() => {
                  if (currentPage > 1) this.fetchRequests(currentPage - 1);
                }}
              />
            </PaginationItem>

            {/* Next Button */}
            <PaginationItem disabled={requests.length < limit}>
              <PaginationLink
                next
                onClick={() => {
                  if (requests.length === limit) this.fetchRequests(currentPage + 1);
                }}
              />
            </PaginationItem>

            <span style={{ fontSize: 16, marginTop: 5, marginLeft: 10 }}>
              Page {currentPage}
            </span>
          </Pagination>
        </div>
      </>
    );
  }
}

export default RequestsPage;
